import $ from 'jquery';
import _ from 'lodash';
//import Rellax from "rellax";
import { FavoriteItem } from "../components/FavoriteItem";
import React from "react";
import { createRoot } from "react-dom/client";
import Cookies from "js-cookie";


export default {

  checkSlidePosition(){
    var $container = $('.event-slider-wrapper');
    var totalSlides = $container.data('slides');
    var currentSlide = $container.data('slide');

    var containerWidth = $container.innerWidth();
    var currentPos = $container.scrollLeft();
    var windowWidth = window.innerWidth;
    //console.log('containerWidth', containerWidth);
    //console.log('currentPos', currentPos);
    //console.log("totalSlides", totalSlides);
    //console.log("currentSlide", currentSlide);

    if(totalSlides > 2){
      $('.event-slider-button').show();

      if(currentPos == 0) {
        $('.event-slider-left').hide();
      }

      if ((currentPos + 1600 > containerWidth) && (containerWidth > 1600) ){
        //$('.event-slider-right').hide();
      }

    } else {
      $('.event-slider-button').hide();
    }
    /*
    if(totalSlides > 2){
      $('.event-slider-button').show();

      if(currentSlide == 1){
        $('.event-slider-left').hide();
      }
      if(currentSlide == totalSlides){
        $('.event-slider-right').hide();
      }

    } else {
      $('.event-slider-button').hide();
    }
    */
  },

  move(direction) {
    var $container = $('.event-slider-wrapper');
    var currentPosition = parseInt($container.scrollLeft());
    var totalSlides = $container.data('slides');
    var currentSlide = $container.data('slide');    

    if(direction == 'left' && currentSlide > 1){
      $container.data('slide', currentSlide - 1);
      $container.animate( { scrollLeft: '-=470' }, 1000, 'swing', () => {
        this.checkSlidePosition();
      });
    } else if(currentSlide < totalSlides) {
      $container.data('slide', currentSlide + 1);      
      $container.animate( { scrollLeft: '+=470' }, 1000, 'swing', () => {
        this.checkSlidePosition();
      });
    }

  },

  toggleSubMenu(el) {
    $('#menu-overlay .menu').toggleClass('sub-menu-active');
    $(el).toggleClass('active');
    $(el).next('.sub-menu').toggleClass('active');
  },


  init() {

    $('.mobile-menu-icon').on('click', function(){
      $("#menu-overlay").toggleClass("menu-show");
      $('.header').toggleClass('menu-show');
    });

    $('.menu-overlay-close').on('click', function(){
      $("#menu-overlay").removeClass("menu-show");
      $('.header').removeClass('menu-show');
    });

    var checkHeader = _.throttle(() => {
      let scrollPosition = Math.round(window.scrollY);
      if (scrollPosition > 0){
        $('.header').addClass('sticky');
      } else {
        $('.header').removeClass('sticky');
      }
    }, 200, { 'leading': true });

    window.addEventListener('scroll', checkHeader);

    const scrollbarWidth = window.innerWidth - document.body.clientWidth;
    document.documentElement.style.setProperty(
        "--scrollbarWidth",
        `${scrollbarWidth}px`
    );

    document.querySelectorAll('.favorite-comp').forEach(element => {
        const root = createRoot(element);
        root.render(<FavoriteItem eventId={element.getAttribute('event-id')} />);
    });

    const favoriteEvents = Cookies.get("favorite_events")
        ? JSON.parse(Cookies.get("favorite_events"))
        : [];
    favoriteEvents.forEach(eventId => {
      const element = document.querySelector(
          `.programm-item[data-evid="${eventId}"]`
      );
      if (element) {
        element.classList.add("filter-type-favorited");
      }
    });

    /*const favorote = createRoot(
        document.getElementById("modern-slider")
    );
    modernRoot.render(
        <StyleSlider onChange={this.onChangeModernSlider} />
    );

    /*if ( $('#overlay24-one').length) {
      var rellax = new Rellax(".overlay24-one");
    }
    if ($("#overlay24-two").length) {
      var rellax = new Rellax(".overlay24-two");
    }
    if ($("#overlay24-three").length) {
      var rellax = new Rellax(".overlay24-three");
    }
    if ($("#overlay24-four").length) {
      var rellax = new Rellax(".overlay24-four");
    }

    if ($("#overlay-default-one").length) {
        var rellax = new Rellax(".overlay-default-one");
    }

      if ($("#overlay-default-two").length) {
          var rellax = new Rellax(".overlay-default-two");
      }
*/
    /*if ( $( '#spotlight').length ) {
      window.addEventListener( 'scroll', function() {
        // normalize scroll position as percentage
        var scrolled = 1 + (Math.sin(window.scrollY/150) / 5);
        //scrolled = 0.9 + (scrolled / 400);
        //console.log(scrolled);
        var transformValue = 'scale('+scrolled+')';
        var box = document.getElementById('spotlight');
  
        box.style.WebkitTransform = transformValue;
        box.style.MozTransform = transformValue;
        box.style.OTransform = transformValue;
        box.style.transform = transformValue;
  
      }, false);
    }*/

    if ( $( '.event-slider-left').length ) {
      $('.event-slider-left').on('click', () => this.move('left'));
      $('.event-slider-right').on('click', () => this.move('right'));
      this.checkSlidePosition();
    }

    $(".lineup-item-with-bg").on('mouseenter', function(){
      $("#lineup-bg-video").css("mix-blend-mode", "overlay");
    });

    $(".lineup-item-with-bg").on('mouseleave', function(){
      $("#lineup-bg-video").css('mix-blend-mode', 'normal');
    });

    $('.menu-item').on('click', (e) => {
      console.log('clicked');
      this.toggleSubMenu(e.target);
    });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};